export default __webpack_public_path__ + "src/images/packages/marataba-conservation-camps/916dfff76773a3507aace4b92ab42072-1.jpg";